import React, { useState } from 'react';
import { Camera, Heart, MessageCircle, Award, Image } from 'lucide-react';
import Button from '../../components/ui/Button';
import { useSocial } from '../../context/SocialContext';
const FoodieChallenge: React.FC = () => {
  const {
    posts,
    addPost,
    likePost
  } = useSocial();
  const [imageUrl, setImageUrl] = useState('');
  const [description, setDescription] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (imageUrl && description) {
      setIsSubmitting(true);
      try {
        addPost({
          userId: 'user-1',
          userName: 'Terry Crews',
          image: imageUrl,
          description,
          likes: 0,
          comments: 0
        });
        setImageUrl('');
        setDescription('');
      } finally {
        setIsSubmitting(false);
      }
    }
  };
  return <div className="w-full max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-966">
      {/* Header */}
      <div className="bg-gradient-to-r from-[#E84118] to-[#c83616] rounded-lg p-6 md:p-8 text-white mb-6 md:mb-8" data-id="element-967">
        <div className="flex flex-col md:flex-row md:items-center md:justify-between" data-id="element-968">
          <div className="mb-4 md:mb-0" data-id="element-969">
            <h1 className="text-2xl md:text-3xl font-bold mb-2" data-id="element-970">
              Foodie Challenge
            </h1>
            <p className="text-base md:text-lg opacity-90" data-id="element-971">
              Share your best food photos and win a free lunch!
            </p>
          </div>
          <div className="bg-white bg-opacity-20 rounded-lg px-4 py-3 text-sm md:text-base" data-id="element-972">
            <span className="font-medium" data-id="element-973">This month's theme:</span>
            <br data-id="element-974" />
            "Office Lunch Goals"
          </div>
        </div>
      </div>
      {/* Upload Form */}
      <div className="bg-white rounded-lg shadow-md p-5 md:p-6 mb-6 md:mb-8" data-id="element-975">
        <div className="flex items-center mb-4" data-id="element-976">
          <Camera className="text-[#E84118] mr-2" size={22} data-id="element-977" />
          <h2 className="text-lg md:text-xl font-bold" data-id="element-978">Share Your Photo</h2>
        </div>
        <form onSubmit={handleSubmit} data-id="element-979">
          <div className="mb-4" data-id="element-980">
            <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-981">
              Photo URL
            </label>
            <div className="flex items-center border border-gray-300 rounded-md overflow-hidden" data-id="element-982">
              <div className="bg-gray-100 p-3" data-id="element-983">
                <Image size={18} className="text-gray-500" data-id="element-984" />
              </div>
              <input type="text" value={imageUrl} onChange={e => setImageUrl(e.target.value)} placeholder="Enter image URL" className="w-full px-3 py-2 border-0 focus:ring-0 focus:outline-none" data-id="element-985" />
            </div>
          </div>
          <div className="mb-5" data-id="element-986">
            <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-987">
              Description
            </label>
            <textarea value={description} onChange={e => setDescription(e.target.value)} placeholder="Tell us about your food..." className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-[#E84118] focus:border-[#E84118]" rows={3} data-id="element-988" />
          </div>
          <div className="flex justify-end" data-id="element-989">
            <Button type="submit" disabled={isSubmitting} data-id="element-990">
              {isSubmitting ? 'Sharing...' : 'Share Photo'}
            </Button>
          </div>
        </form>
      </div>
      {/* Challenge Rules */}
      <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4 mb-6 md:mb-8" data-id="element-991">
        <h3 className="font-medium text-yellow-800 mb-2 flex items-center" data-id="element-992">
          <Award className="mr-2 text-yellow-600" size={18} data-id="element-993" />
          Challenge Rules
        </h3>
        <ul className="list-disc list-inside text-sm text-yellow-700 space-y-1" data-id="element-994">
          <li data-id="element-995">Share photos of your best office lunches</li>
          <li data-id="element-996">One submission per day</li>
          <li data-id="element-997">Most liked photo by month-end wins a free lunch!</li>
          <li data-id="element-998">Photos must be your own</li>
        </ul>
      </div>
      {/* Posts Feed */}
      <h2 className="text-lg md:text-xl font-bold mb-4" data-id="element-999">Recent Submissions</h2>
      <div className="space-y-6" data-id="element-1000">
        {posts.length === 0 ? <div className="bg-white rounded-lg shadow-md p-8 text-center" data-id="element-1001">
            <Camera className="mx-auto text-gray-400 mb-3" size={32} data-id="element-1002" />
            <p className="text-gray-500" data-id="element-1003">
              No photos yet. Be the first to share!
            </p>
          </div> : posts.map(post => <div key={post.id} className="bg-white rounded-lg shadow-md overflow-hidden" data-id="element-1004">
              <img src={post.image} alt="Food" className="w-full h-64 sm:h-72 md:h-80 object-cover" data-id="element-1005" />
              <div className="p-4 md:p-5" data-id="element-1006">
                <div className="flex items-center mb-4" data-id="element-1007">
                  <div className="w-10 h-10 bg-gray-200 rounded-full flex items-center justify-center mr-3" data-id="element-1008">
                    {post.userName.charAt(0)}
                  </div>
                  <div data-id="element-1009">
                    <div className="font-medium" data-id="element-1010">{post.userName}</div>
                    <div className="text-xs text-gray-500" data-id="element-1011">
                      {post.createdAt.toLocaleDateString()}
                    </div>
                  </div>
                </div>
                <p className="text-gray-700 mb-4" data-id="element-1012">{post.description}</p>
                <div className="flex items-center space-x-6" data-id="element-1013">
                  <button onClick={() => likePost(post.id)} className="flex items-center text-gray-600 hover:text-[#E84118] transition-colors" data-id="element-1014">
                    <Heart size={18} className="mr-1" data-id="element-1015" />
                    <span data-id="element-1016">{post.likes}</span>
                  </button>
                  <button className="flex items-center text-gray-600" data-id="element-1017">
                    <MessageCircle size={18} className="mr-1" data-id="element-1018" />
                    <span data-id="element-1019">{post.comments}</span>
                  </button>
                </div>
              </div>
            </div>)}
      </div>
    </div>;
};
export default FoodieChallenge;